import c from "../../../utils/constants";

class MediaFilterController {
  constructor($scope, FilterService) {
    "ngInject"

    this.filterService = FilterService;
    
    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }
  
  $onInit() {
    this.setFilterOptions();
  }

  setFilterOptions() {
    this.filterOptions = this.filterService.getMediaFilterOptions();
  }

  onFilterChagne(newval, oldval) {
    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }
  
}

export default MediaFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/media-filter/media-filter.controller.js
 **/